import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import Button from "@mui/material/Button";
import Context from "../../../../context/Context";
import { Modal } from "react-bootstrap";
import CameraIcon from '@mui/icons-material/Camera';
import Webcam from "react-webcam";
import './styles.css'
import toast from "react-hot-toast";

export const PhotoModal = ({
  status,
  vagao_Serial,
  takePhoto,
  setTakePhoto,
  setImageUrl,
  imageUrl
}) => {

  const {
  } = useContext(Context);


  const [showPhoto, setShowPhoto] = useState(false);
  const webcamRef = useRef(null)

  const handleShowPhoto = () => { setShowPhoto(true) };

  const handleClosePhoto = () => {
    setShowPhoto(false)
  };

  const videoConstrains = {
    width: 540,
    facingMode: "environment"
  }

  const capturePhoto = useCallback(async (vagao_Serial) => {

    try {
      const imageSrc = webcamRef.current.getScreenshot()

      setTakePhoto({
        url: dataURLtoFile(imageSrc, vagao_Serial),
        vagaoKey: vagao_Serial
      })

      setImageUrl(imageSrc)
    } catch {
      toast.error("Camera não carregada... Aguarde", {
        duration: 4000,
      });
    }

  }, [webcamRef])

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  return (
    <>
      {status === "LIBERADO" && (
        <Button
          className="ms-2 mb-3"
          onClick={handleShowPhoto}
          variant="contained"
        >
          Tirar Foto
        </Button>
      )}

      <Modal
        size="lg"
        className="modal-webcan"
        show={showPhoto}
        keyboard={false}
        backdrop="static"
        onHide={handleClosePhoto}
      >
        {!takePhoto.url ? (
          <>
            <Modal.Body className="modal-body-container" id="modal-body">
              <div className="video-container">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  screenshotFormat="image/jpg"
                  videoConstraints={videoConstrains}
                  mirrored={false}
                />
              </div>
            </Modal.Body>
            <Button
              onClick={() => capturePhoto(vagao_Serial)}
            >
              <CameraIcon />
            </Button>

          </>
        ) :
          <>
            <Modal.Body className="modal-body-container" id="modal-body">
              <img src={imageUrl} />
            </Modal.Body>
            <div className="d-flex justify-content-evenly">

              <Button
                onClick={() => {
                  // setImageUrl(null)
                  setTakePhoto({
                    url: null,
                    vagaoKey: 0
                  })
                }
                }
              >
                TIRAR FOTO NOVAMENTE
              </Button>

              <Button
                onClick={() => {
                  handleClosePhoto(
                  )
                }
                }
              >
                CONFIRMAR
              </Button>
            </div>
          </>
        }
      </Modal>
    </>
  );
}